import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signUpWithEmail } from '../services/authService';

interface UseEmailRegisterReturn {
  isLoading: boolean;
  error: string | null;
  handleEmailRegister: (email: string, password: string, confirmPassword: string) => Promise<void>;
}

export const useEmailRegister = (): UseEmailRegisterReturn => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const handleEmailRegister = async (email: string, password: string, confirmPassword: string) => {
    if (password !== confirmPassword) {
      setError('Die Passwörter stimmen nicht überein');
      return;
    }

    try {
      setIsLoading(true);
      setError(null);
      await signUpWithEmail(email, password);
      navigate('/chat');
    } catch (error: any) {
      console.error('Error during registration:', error);
      setError(error.message || 'Registrierung fehlgeschlagen');
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    error,
    handleEmailRegister
  };
}; 